<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>จัดการร้านค้า</strong></v-card-title>
          </v-layout>
          <!-- <v-layout row wrap justify-end>
            <v-flex xs4 sm1 md1 lg1>
              <v-btn class="addbuttonstyle" outlined color="indigo lighten-3" @click="openimportfilemodal()">
                <v-icon>mdi-publish</v-icon>&nbsp;
                Import
              </v-btn>
            </v-flex>
            <v-flex xs4 sm2 md2 lg2>
              <v-btn class="mx-2" outlined color="indigo lighten-2" @click="opencustomermodal('')">
                <v-icon>mdi-plus</v-icon>&nbsp;
                เพิ่มร้านค้า
              </v-btn>
            </v-flex>
            <v-flex xs5 sm2 md2 lg2>
              <v-btn class="mx-2" outlined color="indigo lighten-2" @click="opencustomermodal('')">
                <v-icon>mdi-plus</v-icon>&nbsp;
                เพิ่มลูกค้า
              </v-btn>
            </v-flex>
          </v-layout> -->
          <br />
        <v-layout justify-center>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>รหัสร้านค้า</strong></p>
                <v-text-field v-model="username_search" outlined clearable dense v-on:input="userfilterfunction()" color="pink lighten-3"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อ-สกุล</strong></p>
                <v-text-field v-model="name_search" outlined clearable dense v-on:input="userfilterfunction()" color="pink lighten-3"></v-text-field >
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5 v-for="(searchitem, i) in searchitems" :key="i">
                   <p style="color:#4C4C4C; font-size:90%;"><strong>{{searchitem.text}}</strong></p>
                    <v-combobox
                      v-model="searchitem.model"
                      :items="searchitem.items"
                      :return-object="false"
                      hide-selected
                      outlined
                      clearable
                      dense
                      multiple
                      persistent-hint
                      small-chips
                      v-on:input="userfilterfunction()"
                      color="pink lighten-3"
                    ></v-combobox>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 px-3>
                  <v-layout align-end justify-end>
                    <div class="px-1">
                      <v-btn class="px-3" outlined color="indigo lighten-3" @click="openimportfilemodal()">
                        <v-icon>mdi-publish</v-icon>&nbsp;Import
                      </v-btn>
                    </div>
                    <div class="px-1">
                      <v-btn class="px-3" outlined color="indigo lighten-2" @click="opencustomermodal('')">
                        <v-icon>mdi-plus</v-icon>&nbsp;เพิ่มร้านค้า
                      </v-btn>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            <br />
          <v-data-table
            :headers="headers"
            :items="userdata_view"
            :items-per-page="10"
            class="elevation-3"
            :loading='loading'
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100]
            }"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="opencustomermodal(item._id)">{{ item.username }}</td>
                  <td @click="opencustomermodal(item._id)">{{ item.name }}</td>
                  <td @click="opencustomermodal(item._id)">{{ item.address }}</td>
                  <td @click="opencustomermodal(item._id)">{{ item.tel }}</td>
                  <td @click="opencustomermodal(item._id)">{{ item.adminref }}</td>
                  <td @click="opencustomermodal(item._id)">{{ item.groupprice }}</td>
                  <td>
                    <v-btn class="ma-2" outlined small fab color="pink lighten-2" @click="opencustomermodal(item._id)">
                      <v-icon meduim>mdi-pencil</v-icon>
                    </v-btn>
                     <v-btn class="ma-2" outlined small fab color="red" @click="deletecustomer(item._id, item.username)">
                      <v-icon meduim>mdi-delete-forever</v-icon>
                    </v-btn>
                  </td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        <Customermodal  :parentgetdata="getdata" />
        <Importfilemodal :userparentgetdata="getdata" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Customermodal from '@/components/Customermodal'
import Importfilemodal from '@/components/Importfilemodal'
import axios from 'axios'
import swal from 'sweetalert'
import { sync } from 'vuex-pathify'
export default {
  components: {
    Customermodal,
    Importfilemodal
  },
  data: () => ({
    loading: false,
    headers: [
      { text: 'รหัสร้านค้า', align: 'center', sortable: false, value: 'username' },
      { text: 'ชื่อ-สกุล', align: 'center', sortable: false, value: 'name' },
      { text: 'ที่อยู่', align: 'center', sortable: false, value: 'address' },
      { text: 'เบอร์โทร', align: 'center', sortable: false, value: 'tel' },
      { text: 'เจ้าหน้าที่ผู้ดูแล', align: 'center', sortable: false, value: 'adminref' },
      { text: 'รหัสตารางสินค้า', value: 'groupprice_no', sortable: false, align: 'center' },
      { text: 'แก้ไข/ลบ', value: 'action', sortable: false, align: 'center' }
    ],
    userdatas: [],
    userdata_view: [],
    name_search: '',
    username_search: '',
    searchitems: [
      { text: 'เจ้าหน้าที่ผู้ดูแล', items: [], itemtext: 'adminref', model: [] },
      { text: 'รหัสตารางราคา', items: [], itemtext: 'groupprice', model: [] }
    ]
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin') {
        this.getdata()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    async getdata () {
      try {
        this.loading = true
        this.currentcustomerdata = ''
        let { data } = await axios.get(`${process.env.VUE_APP_API}/user/getinfo/customer`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.userdatas = data
        this.userdata_view = this.userdatas
        for (const searchitem of this.searchitems) {
          searchitem.items = searchitem.items.length === 0 ? this.userdatas.map(usdata => { return usdata[searchitem.itemtext] }).filter(us => us) : searchitem.items
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    opencustomermodal (id) {
      this.customermodal = true
      this.currentcustomerdata = id !== '' ? JSON.stringify(this.userdatas.find(us => us._id === id)) : ''
    },
    openimportfilemodal () {
      this.importfilemodal = true
      this.importmodel = 2
    },
    async deletecustomer (id, name) {
      try {
        await swal({
          title: `คุณแน่ใจที่จะลบร้านค้า ${name} ?`,
          icon: 'warning',
          buttons: ['ยกเลิก', 'ลบ'],
          dangerMode: true
        }).then(async (willDelete) => {
          if (willDelete) {
            let { data } = await axios.delete(`${process.env.VUE_APP_API}/user/delete/${id}`, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            if (data) {
              await swal(`ร้านค้า ${name} ถูกลบแล้ว!`, {
                icon: 'success',
                buttons: 'ตกลง'
              })
              this.getdata()
            }
          }
        })
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    userfilterfunction () {
      this.userdata_view = this.userdatas.filter(user => {
        let condition = [
          this.name_search ? (user.name.toLowerCase()).includes((this.name_search).toLowerCase()) : true,
          this.username_search ? (user.username.toLowerCase()).includes((this.username_search).toLowerCase()) : true,
          this.searchitems[0].model.includes(user.adminref) || !this.searchitems[0].model.length,
          this.searchitems[1].model.includes(user.groupprice) || !this.searchitems[1].model.length
        ]
        return condition.every(con => con)
      })
    }
  },
  computed: {
    customermodal: sync('customermodal'),
    currentcustomerdata: sync('currentcustomerdata'),
    importfilemodal: sync('importfilemodal'),
    importmodel: sync('importmodel')
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}
.v-data-table {
    font-family: 'Kanit';
}
td {
  max-width: 90px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>

<style>
.swal-overlay--show-modal .swal-modal {
  font-family: 'Kanit' !important;
}
.swal-title {
  font-size: 23px;
}
.swal-button--danger {
  background-color: #E17A82;
  border: 0px;
  width: 100px;
}

</style>
